import { Text } from '@fluentui/react';
import React from 'react';
import './NewTicketViewCards.scss';

interface IProps {
    /**
     * Card heading. Takes a node rather than a string so call sites pass a
     * literal `<Trans>` — `<Trans>{title}</Trans>` here would resolve at runtime
     * but is invisible to static key extraction. Omitted for cards whose body
     * carries its own heading.
     */
    title?: React.ReactNode;
    /** Extra class for card-specific overrides. */
    className?: string;
    /** Hides the card entirely — keeps hide-when-empty logic at the call site. */
    isVisible?: boolean;
    useCardLayout?: boolean;
    legacyTitle?: React.ReactNode;
    legacyTitleClassName?: string;
    testId?: string;
    children: React.ReactNode;
}

/**
 * Shared card chrome for the request-detail surfaces. The new ticket view groups
 * every block (Basic Information, Product Details, Contextual Details, Additional
 * details, …) into bordered cards, so this keeps that chrome in one place instead
 * of repeating the border/padding on each section.
 */
const DetailCard = ({
    title,
    className,
    isVisible = true,
    useCardLayout = true,
    legacyTitle,
    legacyTitleClassName = 'dp-content-title',
    testId,
    children
}: IProps) => {
    if (!isVisible) {
        return null;
    }

    if (!useCardLayout) {
        return (
            <>
                {legacyTitle && (
                    <div className={legacyTitleClassName}>
                        <Text>{legacyTitle}</Text>
                    </div>
                )}
                {children}
            </>
        );
    }

    return (
        <div className={`ntv-detail-card${className ? ` ${className}` : ''}`} data-testid={testId}>
            {title && (
                <div className="ntv-detail-card-title">
                    <Text>{title}</Text>
                </div>
            )}
            {children}
        </div>
    );
};

export default DetailCard;
